import bankStyles from '../../assets/css/banks.module.css';
import BankPages from './BankPages';
import LoadMorePagination from './LoadMorePagination';
import { DEFAULT_PAGE_SIZE, useBankPages } from './useBankPages';
import { Ref, RefObject } from 'react';
import { Bank, BankCountry, BanksPage } from '../../services/interfaces/bank.interface';

interface PaginatedBanksProps {
	country: BankCountry;
	searchFilter: string;
	searchRef?: Ref<HTMLInputElement>;
	onBankSelect(bank: Bank): void;
}

const PaginatedBanks = ({ searchFilter, country, searchRef, onBankSelect }: PaginatedBanksProps) => {
	const { pages, size, setSize, isLoading, hasNext } = useBankPages(country, searchFilter);

	const isLoadingMore = isLoading || (size > 0 && pages && typeof pages[size - 1] === 'undefined');
	const isEmpty = pages?.[0]?.banks.length === 0;
	const nextPageSize = calculateNextPageSize(pages);

	return (
		<div className={bankStyles['paginated-banks']}>
			<div className={bankStyles['paginated-banks-container']}>
				<BankPages
					pages={pages}
					isEmpty={isEmpty}
					isLoadingMore={isLoadingMore}
					nextPageSize={nextPageSize}
					onBankSelect={onBankSelect}
				/>
			</div>
			<div className={bankStyles['paginated-banks-container']}>
				<LoadMorePagination
					setSize={setSize}
					hasNext={!!hasNext}
					isLoadingMore={!!isLoadingMore}
					isEmpty={isEmpty}
					searchRef={searchRef as RefObject<HTMLInputElement>}
				/>
			</div>
		</div>
	);
};

export default PaginatedBanks;

function calculateNextPageSize(pages: Array<BanksPage> | undefined) {
	if (!pages) return;

	const lastPage = pages[pages.length - 1];
	if (!lastPage.pagination.next) return 0;

	const total = pages[0].pagination.total;
	const remaining = total - lastPage.pagination.next.offset;
	return remaining > DEFAULT_PAGE_SIZE ? DEFAULT_PAGE_SIZE : remaining;
}
